import React from 'react'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import './Offers.css';

function Offers() {
    var settings = {  
        infinite: true,  
        speed: 600,  
        slidesToShow: 1,  
        slidesToScroll: 1 , 
        autoplay:true
        };
    return (
        <div className="offers">         
               <Slider {...settings} style={{backgroundColor:"#d33342"}}>  
                 <div className="wdt">  
                    <img  className="img" src= {'assets/offer1.jpg'}  alt="first offer" />  
                 </div>  
                 <div className="wdt">  
                    <img className="img"   src= {'assets/offer2.jpg'}  alt="second offer" />  
                 </div>  
                 <div className="wdt">  
                    <img  className="img" src= {'assets/offer3.jpg'}  alt="third offer" />  
                 </div>  
                 <div className="wdt">  
                    <img  className="img" src= {'assets/offer4.jpg'}  alt="fourth offer" />  
                 </div >  
                 <div className="wdt">  
                    <img  className="img" src= {'assets/offer5.jpg'}  alt="fifth offer" />  
                 </div>  
                 <div className="wdt">  
                    <img  className="img" src= {'assets/offer6.jpg'}  alt="sixth offer" />  
                 </div>  
               </Slider>   
        </div>
    )
}

export default Offers;
